module.exports = __webpack_public_path__ + "img/icon-visa.014ba138.svg";